"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PatioOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M29.7 7.3C23 .8 11.3.3 3.7 6L2.4 7.2A1 1 0 003 9h12v9h-5a1 1 0 000 2h5v9a1 1 0 002 0v-9h5a1 1 0 000-2h-5V9h12a1 1 0 001-.6 1 1 0 00-.3-1.1zM5.8 7a18.8 18.8 0 0120.4 0z"/><path d="M10 22H4v-5a1 1 0 00-2 0v12a1 1 0 002 0v-5h5v5a1 1 0 002 0v-6a1 1 0 00-1-1zM29 16a1 1 0 00-1 1v5h-6a1 1 0 00-1 1v6a1 1 0 002 0v-5h5v5a1 1 0 002 0V17a1 1 0 00-1-1z"/>';
var PatioOutlineSVG = function PatioOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.PatioOutlineSVG = PatioOutlineSVG;
PatioOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(PatioOutlineSVG);
exports.default = _default;